import { useEffect, useRef } from "react";

/**
 * Self-ticking text: updates its own text node every second instead of
 * re-rendering, so a live elapsed label costs no React commit while a turn
 * streams.
 */
export function LiveText({ compute }: { compute: () => string }) {
  const textRef = useRef<HTMLSpanElement>(null);
  const computeRef = useRef(compute);
  computeRef.current = compute;
  const initialText = compute();

  useEffect(() => {
    const updateText = () => {
      if (textRef.current) {
        textRef.current.textContent = computeRef.current();
      }
    };
    updateText();
    const id = setInterval(updateText, 1000);
    return () => clearInterval(id);
  }, []);

  return <span ref={textRef}>{initialText}</span>;
}
